var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('canvas',{staticStyle:{"cursor":"pointer"},attrs:{"id":"canvas_1","width":"134","height":"36"},on:{"click":function($event){return _vm.draw()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }